<template>
  <div class="column-container">
    <asset-summary></asset-summary>

    <div class="showcase column-container" :class="[`showcase-${size}`]">
      <div class="stub top-nav">
        <img :src="topbar_stub" />
      </div>

      <div class="wallpaper">
        <img :src="wallpaper" />
      </div>

      <component
        :is="bannerComponent(currentResource)"
        :resource="currentResource"
      ></component>

      <div class="site">
        <img class="stub" :src="site_stub" />
        <static-banner
          :resource="static_banner"
          v-if="static_banner"
        ></static-banner>
      </div>
    </div>
  </div>
</template>

<script>
import AssetSummary from '@components/AssetSummary.vue';
import RendersBannerComponent from '@mixins/RendersBannerComponent';
import Banner from './Banner';
import { serviceUrl } from '@/support';
import StaticBanner from './banners/StaticBanner';
import { mapGetters } from 'vuex';

export default {
  mixins: [RendersBannerComponent],

  computed: {
    ...mapGetters(['currentResource']),

    wallpaper() {
      return serviceUrl([
        'raw/content',
        this.currentResource.showcase().wallpaper(),
      ]);
    },

    static_banner() {
      return this.currentResource.showcase().static();
    },

    size() {
      return this.currentResource.espnUapInfo().width === 1280 ? 'xl' : 'l';
    },

    topbar_stub() {
      return require(`../assets/stub-espn-topbar--${this.size}.jpg`);
    },

    site_stub() {
      return require(`../assets/stub-espn-content--${this.size}.png`);
    },
  },

  components: {
    AssetSummary,
    StaticBanner,
  },
};
</script>

<style lang="scss" scoped>
.showcase {
  position: relative;
  width: 100%;

  .wallpaper {
    position: absolute;
    top: 109px;
    left: 50%;
    transform: translateX(-50%);
    width: 1680px;
    height: 1050px;

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      z-index: 3;
      position: absolute;
      bottom: 0;
      left: 0;
      background: url(https://secure.espncdn.com/ad/doubleclick/wallpaperfade_XL.png)
        bottom left repeat-x;
    }
  }

  .banner-html5 {
    position: relative;
  }

  .top-nav,
  .site {
    position: relative;
    z-index: 5;

    .stub {
      filter: grayscale(1);
    }
  }

  .top-nav {
    filter: grayscale(1);
    margin-bottom: 20px;
    background: url(../assets/stub-espn-topbar-repeat.jpg) top left repeat-x
      transparent;
    width: 100%;
    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.3);
    border-top: 1px solid #ccc;
    text-align: center;
    line-height: 0;
  }

  .site {
    margin-top: 20px;

    .banner {
      position: absolute;
      right: 10px;
      top: 358px;
    }
  }

  &.showcase-l {
    .wallpaper {
      width: 1280px;
      height: 455px;

      &:after {
        background-image: url(https://secure.espncdn.com/ad/doubleclick/wallpaperfade_L.png);
      }
    }

    .site .banner {
      right: 10px;
      top: 375px;
    }
  }
}
</style>
